module.exports = __webpack_public_path__ + "static/media/fallbackimage.92e656b9.png";